module.exports = __webpack_public_path__ + "static/media/gensuite-logo.521e7570.png";